<template>
  <el-container class="indexman">
    <!-- 头部 -->
    <el-header>
      <!-- 头部组件 -->
      <app-header :reload="reload"></app-header>
    </el-header>
    <el-container>
      <!-- 侧边栏 -->
      <el-aside>
        <!-- 侧边栏组件 -->
        <app-aside ref="aside" :reload="reload"></app-aside>
      </el-aside>
      <!-- 主体 -->
      <el-main>
        <!-- 设置子路由出口 -->

        <div class="main_content">
          <!-- 面包屑 -->
          <div class="flix">
            <div class="mian_nav">
              <div
                class="nav_title"
                v-for="(item, index) in title"
                :key="index"
                :class="{ isnav_title: isnav == index }"
              >
                <h4 @click="navchange(index)">{{ item.name }}</h4>
                <img
                  src="@/assets/closelog.png"
                  alt=""
                  @click="navclose(index, item.name)"
                />
              </div>
            </div>
            <div class="box">
              <el-button @click="toKsPc" v-if="type =='student'">返回</el-button>
            </div>
            <!-- 全部关闭的盒子 -->
            <div class="box" v-if="title.length >= 3 && type != 'student'">
              <el-dropdown trigger="click">
                <el-button>
                  标签选项<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="shutDown('all')"
                    >关闭其他</el-dropdown-item
                  >
                  <el-dropdown-item @click.native="shutDown('keep')"
                    >关闭所有</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <!-- 设置子路由出口 -->
          <transition name="fade-transform">
            <router-view v-if="isRouterAlive"></router-view>
          </transition>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
// 引入侧边栏组件
import AppAside from "./components/AppAside";
// 引入头部组件
import AppHeader from "./components/AppHeader";

export default {
  name: "Layout",
  components: {
    AppAside,
    AppHeader,
  },
  data() {
    return {
      title: [],
      isRouterAlive: true,
      // 左边菜单折叠状态
      isfolding: false,
      type: "", // 是否是考生
    };
  },
  methods: {
    reload() {
      //刷新主页路由的办法
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
    // 全部关闭面包屑
    shutDown(text) {
      //  this.reload()
      if (text === "keep") {
        this.title = [];
        this.navclose();
        this.$refs.aside.isActiveTitle = ["发布试卷"];
        // console.log(this.$refs.aside.isActiveTitle, "清空所有的");
      } else if (text === "all") {
        this.title = this.title.filter((item) => {
          return item.name == this.$route.meta[0];
        });
        this.$refs.aside.isActiveTitle = [`${this.title[0].name}`];
        // console.log(this.title[0].name, "剩下的");
        // console.log(this.$refs.aside.isActiveTitle, "保留当前的");
      }
      // console.log(this.$route.meta[0], "当前路由");
      // console.log(this.title, "面包屑");
    },
    //面包屑
    navchange(e) {
      // console.log(this.title);
      this.isnav = e;
      const b = this.title[e].routername;
      this.$router.push({ name: b });
    },
    navclose(e, name) {
      if (this.title.length == 1 && name == "发布试卷") {
        this.$message.warning("已经是首页了");
        return;
      }
      this.title.splice(e, 1);
      this.$refs.aside.isActiveTitle.splice(e, 1);
      if (this.title.length == 0) {
        this.$refs.aside.isActiveTitle.push("发布试卷");
        this.addNavBottom("发布试卷", "Papers");
        this.$router.push({ name: "Papers" });
      }
      if (this.$route.meta[0] == name) {
        this.$router.go(-1);
      }
    },
    //  添加路由的方法有两个属性，一个是标签的中文名，展示路由导航，一个是router的name
    addNavBottom(name, routername) {
      const addtitle = { name: "", routername: "" };
      addtitle.name = name;
      addtitle.routername = routername;
      this.title.push(addtitle);
    },
    folding() {
      this.isfolding = !this.isfolding;
    },
    toKsPc() {
      // 跳转考生答题界面
      this.$router.push({
        path: "/examination/table",
        query: { type: "ks"},
      });
    },
  },
  created() {
    //  把Navbottom方法写在root上，所有的子组件都可以访问这个方法
    this.$root.$Navbottom = this.addNavBottom;
    this.type = JSON.parse(localStorage.getItem("userlist")).userType; // 是否是考生状态
  },
  computed: {
    isnav() {
      // console.log(this.$router);
      return this.title.indexOf(
        this.title.filter((d) => d.routername === this.$route.name)[0]
      );
    },
  },
  beforeRouteEnter(to, from, next) {
    // console.log(to);
    next((vm) => {
      // console.log(vm); //组件内的路由钩子，这个时候页面还没渲染，所以写一个回调函数拿到vm相当于this
      if (to.name === "home") {
        vm.addNavBottom("主页", to.name); //添加一个面包屑
        vm.$refs.aside.isActiveTitle.push("主页");
      } else {
        vm.addNavBottom(to.meta[0], to.name); //添加一个面包屑
        vm.$refs.aside.isActiveTitle.push(to.meta[0]);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.el-container {
  height: calc(100vh - 80px);
  min-width: 1572px !important;
  position: relative;
}
.indexman {
  height: 100vh;
}
.shengdan {
  width: 300px;
  height: 300px;
  position: absolute;
  left: 300px;
  z-index: 20;
  transform: scale(0.4) translate(200px, -280px);
}
.el-aside {
  background-color: #f8f8f8;
  width: 230px !important;
  height: 100%;
  transition: all 0.3s;
  &::-webkit-scrollbar {
    display: none;
  }
}

.el-header {
  background-color: #fff;
  height: 80px !important;
  //  background-repeat: no-repeat;
  // display: flex;
  // align-items: center;
}
// ::v-deep .el-container {
//   width: 100% !important;
// }
.el-main {
  background-color: #f8f8f8;
  transition: all 0.3s;
  /*&::-webkit-scrollbar {*/
  /*display: none; // 全局项目滚动条隐藏*/
  /*}*/
}
.main_content {
  border-radius: 10px;
  min-width: 1472px;
}
.mian_nav {
  height: 44px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  background-color: #fff;
  border-top-left-radius: 10px;
  overflow-x: auto;
  overflow-y: hidden;
}
.flix {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  border-bottom: 1px solid #f8f8f8;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.box {
  height: 40px;
  ::v-deep .el-dropdown {
    height: 100%;
    width: 110px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .el-button {
    font-size: 15px;
    font-family: PingFang SC;
    width: 110px;
    font-weight: bold;
    color: #ffffff;
    cursor: pointer;
    white-space: nowrap;
    border-right: 1px solid #1890ff;
    background: #1890ff;
    border-top: 1px solid #1890ff;
    border-bottom: 1px solid #1890ff;
  }
}

.nav_title {
  padding: 0px 16px 0px 20px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #d9d9d9;
  background: #eeeeee;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  &:nth-child(1) {
    border-top-left-radius: 10px;
    border-left: 1px solid #d9d9d9;
  }
  h4 {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 26px;
    color: #4d4d4d;
    cursor: pointer;
    white-space: nowrap;
  }
  img {
    margin-left: 21px;
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
}
.isnav_title {
  background-color: rgb(255, 255, 255);
}
/*
enter-active 定义进入过渡的结束状态
leave-active 定义离开过渡的结束状态
 */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

/*
enter定义进入过渡的开始状态
 */
.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}
/*
leave-to离场动画结束后的状态
 */
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
